import storeCollection from './collection'
import storeModel from './model'

export const StoreCollection = storeCollection
export const StoreModel = storeModel

// export const bvueCrudsPagination = Pagination
// import Pagination from './Pagination'

export default {
  install (Vue, options = {}) {
    // Vue.component('bvueCrudsPagination', Pagination)
  }
}



// WEBPACK FOOTER //
// ./src/plugin/index.js